import { select, selectAll } from "@fruugo/utilities";
import {
  closeSideMenu,
  openSideMenu,
  sideMenuClassConfig,
  SideMenuSettings,
} from "./SideMenu";
import { i18n } from "../../i18n";
import { Icon } from "../Icon";
import { CompareSellersComparison } from "./CompareSellersComparison";
import { Sku } from "../../../types";
import { getItemsFromOtherSellers } from "../../api";
import { Loader } from "../Loader";
import { Alert } from "../Alert";
import {
  createGAItem,
  sendViewItemListEvent,
} from "../../analytics/google-analytics";
import { fadeInItems, SellersItemList } from "./SellersItemList";

declare let window: ProductPage;

let listItems: Sku[] | null = null;

const GA_LIST_ID = "compare_sellers_menu";
const GA_LIST_NAME = "Compare Sellers Menu";

export function initCompareSellersMenu() {
  const config = {
    openClass: ".js-open-compare-sellers-menu",
  };

  const sideMenuSettings: SideMenuSettings = {
    position: "right",
    disableScroll: true,
  };

  function openMenu(productId: string, currentSku: Sku) {
    openSideMenu(<CompareSellersMenu />, sideMenuSettings);
    getItemsFromOtherSellers(productId)
      .then((items) => {
        listItems = items;
        sendViewItemListEvent(
          GA_LIST_ID,
          GA_LIST_NAME,
          items.map((item) => createGAItem(item))
        );
      })
      .catch(console.error)
      .finally(() => render(currentSku, listItems))
      .then(fadeInItems);
  }

  selectAll<HTMLElement>(config.openClass)?.forEach((item) => {
    const { productId } = item.dataset;
    if (productId)
      item.addEventListener("click", () => openMenu(productId, window.skuInfo));
  });
}

function render(currentSku: Sku, listItems: Sku[] | null) {
  const root = select(".js-compare-sellers-root");
  const loading = select(".js-compare-sellers-loading");
  if (!root) return;

  if (loading) loading.remove();

  if (!listItems || listItems.length == 0) {
    // Show error alert if fetch errors or there's no items returned
    root.replaceWith(
      <div class="tw:p-4">
        <Alert text={i18n("product.multi-merchant.error")} />
      </div>
    );
  } else {
    root.replaceWith(
      <>
        <CompareSellersComparison sku={currentSku} />
        <SellersItemList
          gaListId={GA_LIST_ID}
          gaListName={GA_LIST_NAME}
          listItems={listItems}
        />
      </>
    );
  }
}
export const CompareSellersMenu = () => {
  return (
    <div class="tw:flex tw:flex-col tw:h-full">
      <header class="d-flex justify-content-between align-items-center sticky-section">
        <h3 class="tw:m-0 tw:font-semibold tw:text-xl tw:text-fruugo-black">
          {i18n("product.multi-merchant.menu.title")}
        </h3>
        <button
          type="button"
          title={i18n("search.page.close")}
          onClick={closeSideMenu}
          class={`button-icon header-icon clear ${sideMenuClassConfig.closeSideMenuClass.replace(
            ".",
            ""
          )}`}
        >
          <Icon name="close" width={24} height={24} />
        </button>
      </header>
      <div class="js-compare-sellers-loading tw:flex tw:flex-1 tw:items-center tw:justify-center">
        <Loader />
      </div>
      <div class="js-compare-sellers-root"></div>
    </div>
  );
};
